import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {ReportTimerFilter} from 'yougile-model'
import {Option} from '@components/common/select/select'
import {Remove} from '@components/statistics/stats-reports/common'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'

interface OuterProps {
  filter: ReportTimerFilter
  stopwatch?: boolean
}

interface Props extends OuterProps {
  update: (filters: ReportTimerFilter) => void
}

export const TimerFilter = (props: Props) => {
  const {filter = {}, update} = props

  const opts = getOpts(props)

  useEffect(() => {
    if (!props.filter) {
      props.update({type: opts[0].value})
    }
  }, [props.filter])

  const change = (value: '' | ReportTimerFilter['type']) => {
    if (value === '') {
      const {type: _, ...newFilter} = filter
      update(newFilter)
    } else {
      update({...filter, type: value})
    }
  }

  return (
    <div className="flex justify-between">
      <DropdownList
        className="w-184"
        initialOpen={!props.filter}
        options={opts}
        value={filter.type || ''}
        onChange={change}
      />
      <Remove update={update} />
    </div>
  )
}

const getOpts = (props: OuterProps) => {
  const {stopwatch = false} = props

  const opts: Array<
    Option & {
      value: ReportTimerFilter['type']
    }
  > = [
    {value: 'set', label: Lang.msg.component.timerFilter.set},
    {value: 'stopped', label: Lang.msg.component.timerFilter.stopped},
    {value: 'not-pinned', label: Lang.msg.component.timerFilter.notPinned}
  ]

  if (stopwatch) {
    opts.push({value: 'pinned', label: Lang.msg.component.timerFilter.pinned})
  } else {
    opts.push({
      value: 'not-set',
      label: Lang.msg.component.timerFilter.notSet
    })
    opts.push({value: 'expired', label: Lang.msg.component.timerFilter.expired})
    opts.push({
      value: 'not-expired',
      label: Lang.msg.component.timerFilter.notExpired
    })
  }

  return opts
}

export const TimerFilterValue = (props: OuterProps) => {
  const filter = props.filter ?? {}
  const opts = getOpts(props)
  const value = opts.find(opt => opt.value === filter.type)

  return <>{value?.label ?? ''}</>
}
